export const mealTypeEnum = {
  Breakfast: 'B',
  Lunch: 'L',
};

export const mealTypeOptions = [
  {
    label: `Breakfast - CN6`,
    value: mealTypeEnum.Breakfast,
  },
  { label: `Lunch - CN7`, value: mealTypeEnum.Lunch },
];

export const mapIdKeyToMealType = {
  B: mealTypeEnum.Breakfast,
  L: mealTypeEnum.Lunch,
};



// WEBPACK FOOTER //
// ./src/pages/ohiodailyworksheetreport/helpers/constants.js